import { GenericObject } from '@/types';

export const HTTP_REQUEST_METHODS = [
  'GET',
  'HEAD',
  'POST',
  'PUT',
  'DELETE',
  'CONNECT',
  'TRACE',
  'OPTIONS',
  'PATCH',
] as const;

export const TRAFFIC_COLORS = {
  hits: '#808080', // $color-gray
  blocked: '#b10000', // $color-bright-red
  reported: '#c1a004', // $color-buddha-gold
  passed: '#4f9d5d', // $color-fruit-salad
  challenge: '#d59a6f', // $color-whisky
  humans: '#8ab9f1', // $color-jordy-blue
  bots: '#ef863f', // $color-jaffa
  originBlocked: '#e16865', // $color-sunglo
  ips: '#8ab9f1', // $color-jordy-blue
  sessions: '#808080', // $color-gray
  bandwidth: '#b1f4e7', // $color-ice-queen
};

/* These colors do not follow the colors.scss, as they're very close to one another and share the same names */
export const STATUS_COLORS = {
  '101': '#5b844a',
  '1xx': '#5b8c3a',
  '200': '#5cb85c',
  '2xx': '#94ba94',
  '301': '#337ab7',
  '302': '#80b2dd',
  '3xx': '#9dbedb',
  '400': '#f0ad4e',
  '401': '#e08b11',
  '403': '#fc9400',
  '404': '#c6b49b',
  '405': '#c66839',
  '4xx': '#f4c2a8',
  '500': '#d9534f',
  '502': '#9e3a37',
  '503': '#722220',
  '504': '#c10500',
  '5xx': '#b2706e',
  origin_400: '#b27f6e',
  origin_403: '#b27a6e',
  origin_500: '#b270fe',
  origin_503: '#b270ae',
  originStatus400: '#4ebeff',
  originStatus403: '#b8e5ff',
  originStatus500: '#af66db',
  originStatus503: '#d6b2ed',
} as GenericObject;

export const BACKEND_SERVICES_STICKINESS_MODELS = [
  {
    name: 'None',
    value: 'none',
  },
  {
    name: 'Auto Cookie',
    value: 'autocookie',
  },
  {
    name: 'Custom Cookie',
    value: 'customcookie',
  },
  {
    name: 'IP Hash',
    value: 'iphash',
  },
  {
    name: 'Least Connection',
    value: 'least_conn',
  },
];

export const AI_CRAWLERS = new Set(['ai-claude', 'ai-chatgpt', 'ai-perplexity']);

// Excluded tags that should not be shown in the AI Management Table
export const isExcludedTag = (_tagName: string): boolean => {
  return false;
};

export const ACTION_TYPE_MAP: Record<string, string> = {
  'action-monitor': 'monitor',
  'action-global-filter-block': 'block',
};

export const ACTION_DISPLAY_MAP: Record<string, { text: string; badgeClass: string }> = {
  block: { text: 'Global filter block', badgeClass: 'is-blocked' },
  monitor: { text: 'monitor (tag only)', badgeClass: 'is-monitor' },
};
